export default __webpack_public_path__ + "static/media/Rewards_Perk.90599baa.png";